import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import pauseIntroCollageSrc from '../../assets/images/slide/pause-intro-collage.png';
import styles from './PauseSlideContentV2.css';

function PauseSlideContentV2({ spriteVersion }) {
    return (
        <div className={styles.form}>
            <div className={styles.headingSection}>
                <h2 className={styles.heading}>You’re about to become your family’s story keeper</h2>
                <p className={styles.description}>Everything is already included: thoughtful questions, personalized guidance, and a simple way to preserve every story.</p>
            </div>
            <div className={styles.imageWrapper}>
                <img src={pauseIntroCollageSrc} alt='' className={styles.image} />
            </div>
            <div className={styles.highlightCard}>
                <EmojiIcon name='heart-red' version={spriteVersion} className={styles.highlightIcon} />
                <p className={styles.highlightText}>Let’s build your family story</p>
            </div>
        </div>
    );
}

PauseSlideContentV2.propTypes = {
    spriteVersion: PropTypes.string.isRequired
};

export {
    PauseSlideContentV2
};
